import { GAnalytics } from '@ktr/ktr-materialui-react';  


  export function gaEvent(action: string) {
    const category = "Configurator Clampex";
    //ReactGA.event({category: category, action: action});  
    GAnalytics.gaEvent(action, category);
  }
  